import { ISocketCommentProps } from '../types/working-model';
import { GetHv, HvHostMap } from './helpers';

export function GetChat(sessionUuid: string, lang: string): Promise<{ count: number, messages: ISocketCommentProps[] }> {
	return GetHv(HvHostMap.chat, `/e3-chat-messages/${sessionUuid}/${lang}`);
}